module.exports = __webpack_public_path__ + "static/img/brid_native.38eb998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/brid_native.png
// module id = IO8D
// module chunks = 1 3